import React, { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import Grid from 'components/UI/Grid';
import api from 'Api/ApiMethods';
import { UserProfile } from 'models/restTypes';
import UserProfilesDefaultTable from './UserProfilesDefaultTable';

const Container = styled(Grid)`
  height: 100%;
  width: 100%;
  justify-content: flex-start;
`;

const UserProfilesDefault: FC = observer(() => {
  const [data, setData] = useState<UserProfile[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    api
      .getUserProfiles()
      .then((response) => {
        setData(response);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <Container>
      <UserProfilesDefaultTable userProfiles={data} isLoading={loading} />
    </Container>
  );
});

export default UserProfilesDefault;
